import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../../../common/models/api-response.model';
import { Insight } from '../../../../common/models/insight.model';
import { StepTask } from '../../../../common/models/assign-to-me.model';
import { MyInboxService } from '../../../../common/services/my-inbox/my-inbox.service';
import { TenantService } from '../../../../common/services/tenant/tenant.service';
import { EMPLOYEE_ROUTES } from '../../../../common/constants/employee.routing.constants';
import { RequestTypeEnum } from '../../../../common/enums/request-type';
import {
  AssignedTasksAdapter,
  AssignedTasksSort,
  AssignedTasksUiFeatures,
} from './assigned-tasks.adapter';

@Injectable({ providedIn: 'root' })
export class EmployeeAssignedTasksAdapter implements AssignedTasksAdapter {
  private readonly myInboxService = inject(MyInboxService);
  private readonly tenantService = inject(TenantService);

  readonly uiFeatures: AssignedTasksUiFeatures = {
    showResourceTypeFilter: true,
    showOnHold: true,
    showProjectLink: true,
  };

  getTasks(
    page: number,
    perPage: number,
    filter: string,
    sort: AssignedTasksSort,
    search: string,
    additionalFilters?: Record<string, string | string[]>
  ): Observable<ApiResponse<StepTask>> {
    return this.myInboxService.getStepsAssignToMe(
      page,
      perPage,
      filter,
      sort,
      search,
      additionalFilters
    );
  }

  getInsights(): Observable<{ data: Insight[] }> {
    return this.myInboxService.getAssignedToMeInsights();
  }

  exportTasks(form: Record<string, unknown>): Observable<unknown> {
    return this.myInboxService.exportAssignedToMe(form);
  }

  getTaskRouterLink(taskId: number, flowId: number): string[] {
    return [
      this.tenantService.tenantPath(
        `${EMPLOYEE_ROUTES.MY_INBOX.LIST}/${taskId.toString()}/${RequestTypeEnum.ACTION}/${flowId.toString()}`
      ),
    ];
  }

  getRelatedRequestViewLink(childFlowId: number): string {
    return this.tenantService.tenantPath(
      `${EMPLOYEE_ROUTES.MY_INBOX.REQUEST}/${RequestTypeEnum.VIEW}/${childFlowId}`
    );
  }
}
